<template>
  <div
    class="flex bg-white rounded-[10px] gap-4 w-full max-w-full flex-wrap"
    ref="rowEl"
    :class="splitter ? ' p-2 px-[15px]' : 'p-4 px-[30px]'"
  >
    <div class="card border-r-[1px] border-[#F0F0F0] flex-1">
      <div class="card-body">
        <div class="flex items-center justify-start gap-7" :class="splitter ? 'p-2' : 'p-4'">
          <div
            class="flex items-center justify-center bg-[#e8fff3] rounded-full"
            :class="splitter ? ' p-4' : 'p-6'"
          >
            <Square3Stack3DIcon class="size-8 text-primary inline-block" />
          </div>
          <div class="flex flex-col w-full">
            <h5 class="text-[#909090] text-sm">Total Orders</h5>
            <h5 class="text-black font-semibold" :class="splitter ? 'text-[24px]' : 'text-[32px]'">
              {{ totalOrders }}
            </h5>
          </div>
        </div>
      </div>
    </div>
    <template v-for="order_items_by_status_group_item in order_items_by_status_group">
      <div
        class="card border-r-[1px] border-[#F0F0F0] flex-1 last-of-type:border-0"
        :key="order_items_by_status_group_item.id"
        v-if="
          order_items_by_status_group_item.label != 'Shareable' &&
          showDashboardCard(order_items_by_status_group_item.label)
        "
      >
        <div class="card-body">
          <div
            class="flex items-center justify-start"
            :class="splitter ? 'p-2 gap-3' : 'p-4 gap-7'"
          >
            <div
              class="flex items-center justify-center bg-[#e8fff3] rounded-full"
              :class="splitter ? 'p-4' : 'p-6'"
            >
              <component
                :is="getCardIcon(order_items_by_status_group_item.label)"
                class="text-primary inline-block"
                :class="splitter ? 'size-6' : 'size-8'"
              />
            </div>
            <div class="flex flex-col w-full">
              <h5 class="text-[#909090] text-sm">
                {{ order_items_by_status_group_item.label }}
              </h5>
              <h5
                class="text-black font-semibold"
                :class="splitter ? 'text-[24px]' : 'text-[32px]'"
              >
                {{ order_items_by_status_group_item.items_count }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script setup lang="ts">
import { can } from '@/composables';
import { OrderItemsByStatusGroup } from '@/models';
import {
  ArchiveBoxArrowDownIcon,
  ArrowTopRightOnSquareIcon,
  ArrowUpOnSquareIcon,
  PrinterIcon,
  Square3Stack3DIcon,
} from '@heroicons/vue/24/solid';
import { computed, FunctionalComponent, HTMLAttributes, ref, VNodeProps } from 'vue';

defineProps<{
  order_items_by_status_group: OrderItemsByStatusGroup[];
  totalOrders: number;
  splitter?: boolean;
}>();

const rowEl = ref<HTMLElement | undefined>(undefined);

const showDashboardCard = (card_name: string) =>
  computed<boolean>(() => {
    if (can('show-dashboard-card')) {
      return true;
    } else {
      return card_name !== 'Shareable';
    }
  });

const getCardIcon = (card_name: string) => {
  return computed<FunctionalComponent<HTMLAttributes & VNodeProps, {}, any, {}>>(() => {
    if (card_name === 'Fulfilled Orders') {
      return ArchiveBoxArrowDownIcon;
    } else if (card_name === 'Check Print Files') {
      return PrinterIcon;
    } else if (card_name === 'Production') {
      return ArrowUpOnSquareIcon;
    } else if (card_name === 'Shipping') {
      return ArrowTopRightOnSquareIcon;
    } else {
      return Square3Stack3DIcon;
    }
  }).value;
};
</script>
<style lang="scss" scoped></style>
